import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { errorProps } from "../services/errorService";
import { IonItem, IonLabel } from "@ionic/react";
import { R6IonInput } from "./r6ionic/R6IonInput";
import "./userInfoComponent.css";

const UserInfoComponent: FC = () => {
    const { t } = useTranslation();
    const {
        setValue,
        watch,
        formState: { errors },
    } = useFormContext();

    return (
        <>
            <IonItem lines="full" {...errorProps("firstName", errors)}>
                <R6IonInput
                    name="firstName"
                    rules={{
                        required: t("utils.ErrorMessages.required").toString(),
                    }}
                    label={t("general.firstName")}
                />
            </IonItem>
            <IonItem lines="full" {...errorProps("lastName", errors)}>
                <R6IonInput
                    name="lastName"
                    rules={{
                        required: t("utils.ErrorMessages.required").toString(),
                    }}
                    label={t("general.lastName")}
                />
            </IonItem>
            <IonItem lines="full" {...errorProps("dob", errors)}>
                <R6IonInput
                    name="dob"
                    type="date"
                    rules={{
                        required: t("utils.ErrorMessages.required").toString(),
                    }}
                    label={t("myaccount.dateOfBirth")}
                    max={new Date().toISOString().split("T")[0]}
                />
            </IonItem>
        </>
    );
};

export default UserInfoComponent;
